import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import getAmount from 'components/Layout/Mining/MiningCalculator/utils/getAmount';

const RevenueCell = (props: IRevenueCell) => {
  const { state, isCalculatorModifiedByUser, row, period } = props;

  const { t } = useTranslation();
  const isGpuDataProvided = row.watts && row.hash;

  if (!isGpuDataProvided) {
    return <>N/D</>;
  }

  const currentGpu = state?.find((el: { id: number }) => row.id === el.id)!;
  const isGpuModifiedByUser = !(
    isCalculatorModifiedByUser && currentGpu?.quantity === 0
  );

  const classes = classNames('revenue-cell', {
    [`revenue-cell--${period}`]: !!period,
  });

  const profitClasses = classNames('revenue-cell__profit', {
    'revenue-cell__profit--inactive':
      currentGpu.profit === 0 || !isGpuModifiedByUser,
    'revenue-cell__profit--negative':
      currentGpu.profit < 0 && isGpuModifiedByUser,
  });

  return (
    <div className={classes}>
      <div>
        {t('miningCalculator.table.revenue', {
          revenue: getAmount({
            value: currentGpu.revenue,
            period,
            isModifiedByUser: isGpuModifiedByUser,
          }),
        })}
      </div>
      <div className={profitClasses}>
        {t('miningCalculator.table.profit', {
          profit: getAmount({
            value: currentGpu.profit,
            period,
            isModifiedByUser: isGpuModifiedByUser,
          }),
        })}
      </div>
    </div>
  );
};

export default RevenueCell;
